<div class="c-html">
	{{{safeHtmlToRender}}}
</div>

<script>
	const _ = require('../../assets/js/_.js');
	const ID_PREFIX = 'id-';

	component.exports = {
		data () {
			return {
				_,
				html: '',
				safeHtmlToRender: '',
			};
		},
		oninit () {
			if (!Ractive.isServer) {
				_.injectGlobalStyle('https://cdn.jsdelivr.net/gh/highlightjs/cdn-release@11.7.0/build/styles/github.min.css');

				Promise.all([
					// eslint-disable-next-line n/no-missing-import
					import('https://cdn.jsdelivr.net/npm/dompurify@2.4.3/+esm'),
				]).then(([{ default: DOMPurify }]) => {
					let _this = this;

					DOMPurify.removeAllHooks();

					DOMPurify.addHook('afterSanitizeAttributes', (node) => {
						if (node.hasAttribute('href')) {
							node.setAttribute('href', _.normalizeHref(node.getAttribute('href'), ID_PREFIX));
						}

						if (node.hasAttribute('src')) {
							node.setAttribute('src', _.optimizeSrc(node.getAttribute('src'), _this.get('github')));
							node.setAttribute('loading', 'lazy');
						}

						if ('target' in node) {
							if (_.isExternalLink(node.getAttribute('href'))) {
								node.setAttribute('target', '_blank');
							}

							node.setAttribute('rel', 'nofollow noopener noreferrer');
							node.classList.add('router-ignore');
						}
					});

					// if page URL has a hash then scroll page to the anchor
					this.observe('safeHtmlToRender', () => {
						// it appears the observer sometimes executes too soon despite defer: true, so we delay by one cycle here
						setTimeout(() => {
							let anchor = app.router.uri.hash;
							let el = anchor ? this.find(anchor) : null;

							if (el) {
								if (document.visibilityState === 'visible') {
									el.scrollIntoView({
										behavior: 'smooth',
									});
								} else {
									document.addEventListener('visibilitychange', function listener () {
										el.scrollIntoView({
											behavior: 'smooth',
										});

										document.removeEventListener('visibilitychange', listener);
									});
								}
							}
						});
					}, { init: false, defer: true });

					this.observe('html', (html) => {
						this.set('safeHtmlToRender', DOMPurify.sanitize(html));
					});
				});
			}
		},
	};
</script>
